import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';

export function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) { navigate('/'); return; }
      try {
        const res = await api.post('/auth/session', {}, { headers: { 'X-Session-ID': sessionId } });
        setUser(res.data);
        const portal = localStorage.getItem('niko_portal');
        localStorage.removeItem('niko_portal');
        const isAdmin = res.data?.role === 'owner' || res.data?.role === 'admin';
        const dest = portal === 'admin' && isAdmin ? '/admin' : '/';
        window.history.replaceState(null, '', dest);
        navigate(dest, { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate('/login');
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 via-white to-cyan-50">
      <div className="text-center">
        <Loader2 className="w-10 h-10 animate-spin mx-auto text-teal-600 mb-3" />
        <p className="text-gray-500">Signing you in...</p>
      </div>
    </div>
  );
}
